var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"home"},[_c('button',{staticClass:"btn btn-primary",on:{"click":function($event){return _vm.testAxios()}}},[_vm._v(" Test Headers (retrieve all users) ")]),_c('div',[_vm._v(_vm._s(_vm.users))])])
}
var staticRenderFns = []

export { render, staticRenderFns }